export default __webpack_public_path__ + "static/media/avatar_mice3.9a2b837b.mp3";